module.exports = __webpack_public_path__ + "img/tab_button_img2_mobile.bca5bacf.png";